<semeris-header>
  <ng-template #title>
    <div class="help-title-container">
      @if (navigateOnClick) {
        <h2>{{ 'Semeris Docs User Guide' }}</h2>
      }
      <div class="help-embedded-controls">
        <button (click)="onHomeClick($event)" semerisIconButton fastTooltip="Home">
          <mat-icon>home</mat-icon>
        </button>
        @if (!navigateOnClick) {
          <button (click)="onOpenToc()" semerisIconButton fastTooltip="Open table of contents">
            <mat-icon>toc</mat-icon>
          </button>
        }
        @if (mode === HelpComponentMode.Help) {
          <button (click)="onBackClick($event)" [disabled]="!hasBack" semerisIconButton fastTooltip="Back">
            <mat-icon>arrow_back</mat-icon>
          </button>
        }
        @if (mode === HelpComponentMode.Help) {
          <button (click)="onForwardClick($event)" [disabled]="!hasForward" semerisIconButton fastTooltip="Forward">
            <mat-icon>arrow_forward</mat-icon>
          </button>
        }
        @if (!navigateOnClick && mode === HelpComponentMode.Help) {
          <button (click)="onOpenInNewTab()" semerisIconButton fastTooltip="Open in new tab">
            <mat-icon>open_in_new</mat-icon>
          </button>
        }
      </div>
    </div>
  </ng-template>

  <ng-template #rightSide>
    @if (!navigateOnClick) {
      <div class="help-actions">
        @if (mode === HelpComponentMode.Help) {
          <mat-slide-toggle
            color="accent"
            [checked]="!(contextHelpEnabled$ | async)"
            (change)="onContextHelpToggleChange($event.checked)"
            fastTooltip="Lock panel to keep current help content"
            >Pin</mat-slide-toggle
          >
        }
        <button (click)="onClose()" semerisIconButton fastTooltip="Close help">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  </ng-template>
</semeris-header>
<semeris-loader [loading]="loading$ | async"></semeris-loader>

@if (!navigateOnClick) {
  <div class="mode-selector">
    <mat-chip-set aria-label="Help mode selection">
      <mat-chip-option color="accent" (click)="onModeSelected(HelpComponentMode.Help)" [selected]="mode === HelpComponentMode.Help"
        >Help</mat-chip-option
      >
      <mat-chip-option color="accent" (click)="onModeSelected(HelpComponentMode.Updates)" [selected]="mode === HelpComponentMode.Updates"
        >Updates</mat-chip-option
      >
      <ng-container *permissions="[Permissions.READ_GUIDED_TOUR]">
        <mat-chip-option
          color="accent"
          (click)="onModeSelected(HelpComponentMode.GuidedTours)"
          [selected]="mode === HelpComponentMode.GuidedTours"
          >Guided Tours</mat-chip-option
        >
      </ng-container>
      <ng-container *permissions="[Permissions.WRITE_HELP_AI]">
        <mat-chip-option color="accent" (click)="onAiHelpClick()" [selected]="mode === HelpComponentMode.AiHelpMode"
          >AI Answers</mat-chip-option
        >
      </ng-container>
    </mat-chip-set>
  </div>
}

<div class="help-container">
  @if (help$ | async; as help) {
    <semeris-guided-tours [guidedTourParamsExtended]="guidedTourParamsExtended$ | async"></semeris-guided-tours>
    <semeris-ai-help *permissions="[Permissions.WRITE_HELP_AI]"></semeris-ai-help>
    <semeris-help-product-updates></semeris-help-product-updates>
    <div #helpContentEl class="help-content">
      <div class="external-help-content" [innerHTML]="help | safeHtml"></div>
    </div>
  }
  @if (navigateOnClick) {
    @if (toc$ | async; as toc) {
      <div class="help-toc" [innerHTML]="toc | safeHtml"></div>
    }
  }
</div>

<div class="help-footer">
  <span>Need assistance? <a (click)="onContactUsClick($event)">Contact Semeris</a> for further help!</span>
</div>
